import WsSpeechToText from './ws.service';
import { Config } from './config.interface';

export function init(config: Config) {
  const ws = new WsSpeechToText(config);
  return ws;
}
